"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.withPageTimeFieldProps = exports.withPageDateFieldProps = exports.withChartFieldProps = exports.withImageFieldProps = exports.withFileFieldProps = exports.withPageNumberFieldProps = exports.withPageTextFieldProps = void 0;
const lodash_1 = require("lodash");
const react_1 = __importDefault(require("react"));
const getErrorAndWarningProps = ({ errors, warnings, }) => {
    let helperText = '';
    if (errors && errors[0]) {
        helperText = errors[0];
    }
    else if (warnings && warnings[0]) {
        helperText = warnings[0];
    }
    return {
        error: !!(errors && errors[0]),
        warning: warnings && warnings[0] ? true : undefined,
        helperText,
    };
};
const useFilterPageTextFieldProps = (props, type) => {
    const { value, controlDefinition, warnings, readOnly } = props;
    const { label, placeholder, info, oneLine, truncate } = controlDefinition;
    const filteredProps = Object.assign(Object.assign({ type: type || 'text' }, getErrorAndWarningProps(props)), { value,
        warnings,
        label,
        info, placeholder: placeholder || 'No Placeholder', readOnly,
        oneLine,
        truncate });
    return filteredProps;
};
const withPageTextFieldProps = (Component) => {
    return (props) => {
        const filteredProps = useFilterPageTextFieldProps(props);
        return react_1.default.createElement(Component, Object.assign({}, filteredProps));
    };
};
exports.withPageTextFieldProps = withPageTextFieldProps;
const withPageNumberFieldProps = (Component) => {
    return (props) => {
        const filteredProps = useFilterPageTextFieldProps(props, 'number');
        return react_1.default.createElement(Component, Object.assign({}, filteredProps));
    };
};
exports.withPageNumberFieldProps = withPageNumberFieldProps;
const withFileFieldProps = (Component) => {
    return (props) => {
        const filteredProps = useFilterPageTextFieldProps(props, 'file');
        return react_1.default.createElement(Component, Object.assign({}, filteredProps));
    };
};
exports.withFileFieldProps = withFileFieldProps;
const withImageFieldProps = (Component) => {
    return (props) => {
        const filteredProps = useFilterPageTextFieldProps(props, 'image');
        return (react_1.default.createElement(Component, Object.assign({}, Object.assign(Object.assign({}, filteredProps), { width: props.controlDefinition.width, height: props.controlDefinition.height }))));
    };
};
exports.withImageFieldProps = withImageFieldProps;
const withChartFieldProps = (Component) => {
    return (props) => {
        const filteredProps = useFilterPageTextFieldProps(props, 'chart');
        return (react_1.default.createElement(Component, Object.assign({}, Object.assign(Object.assign({}, filteredProps), { chartType: props.controlDefinition.chartType, chartOptions: props.controlDefinition.chartOptions, height: props.controlDefinition.height }))));
    };
};
exports.withChartFieldProps = withChartFieldProps;
const withPageDateFieldProps = (Component) => {
    return (props) => {
        const { value, controlDefinition, warnings, readOnly, defaultDateTimeFormat } = props;
        const valueToUse = value && (typeof value === 'number' || typeof value === 'string') ? new Date(value) : value;
        const { label, placeholder, info, oneLine, truncate } = controlDefinition;
        const filteredProps = Object.assign(Object.assign({ label,
            placeholder,
            info, value: valueToUse }, getErrorAndWarningProps(props)), { warnings, onChange: lodash_1.noop, readOnly,
            oneLine,
            truncate,
            defaultDateTimeFormat });
        return react_1.default.createElement(Component, Object.assign({}, filteredProps));
    };
};
exports.withPageDateFieldProps = withPageDateFieldProps;
const withPageTimeFieldProps = (Component) => {
    return (props) => {
        const { value, controlDefinition, readOnly, defaultDateTimeFormat } = props;
        const { label, placeholder, info, oneLine, truncate } = controlDefinition;
        const valueToUse = value && typeof value === 'number' ? new Date(value) : null;
        const filteredProps = Object.assign(Object.assign({ value: valueToUse }, getErrorAndWarningProps(props)), { onChange: lodash_1.noop, label,
            placeholder,
            info,
            readOnly,
            oneLine,
            truncate,
            defaultDateTimeFormat });
        return react_1.default.createElement(Component, Object.assign({}, filteredProps));
    };
};
exports.withPageTimeFieldProps = withPageTimeFieldProps;
//# sourceMappingURL=PageHelpers.js.map